<template>
  <modal-vue @close="handleToggleModal" :modalActive="modals[modalName]" :hasFooterBorder="true">
    <template #header>
      <div class="text-left px-[16px] flex">
        <strong>Editando {{ isSelectAll ? totalRows : ids?.length }} plantões</strong>
      </div>
    </template>
    <div class="station-form-container">
      <LocaleAndScheduleForm
        v-model:company="formStates.company"
        v-model:health-unit="formStates.healthUnit"
        v-model:schedule="formStates.schedule"
        v-model:doctor="formStates.doctor"
      />
      <div class="w-full border-b-2 mb-4"></div>
      <PricesForm
        v-model:doctor="formStates.doctor"
        v-model:value="formStates.value"
        v-model:inCash="formStates.inCash"
        v-model:advanceRequested="formStates.advanceRequested"
        v-model:advancePaid="formStates.advancePaid"
        v-model:modified-value="formStates.modifiedValue"
        :modifiedValueEnabled="true"
        :company="formStates.company"
        :urlConviteDoctor="formStates.infos.urlConviteDoctor"
      />
      <div class="w-full border-b-2 mb-4"></div>
      <HourAndDateForm
        v-model:date="formStates.date"
        v-model:timezone="formStates.timezone"
        v-model:startHour="formStates.startHour"
        v-model:endHour="formStates.endHour"
        :isUpdateMode="true"
        @validation-status="handleValidation"
      />
      <div class="w-full border-b-2 mb-4"></div>
      <StationDetailsForm
        v-model:station-type="formStates.stationType"
        v-model:our-team="formStates.ourTeam"
      />
      <template v-if="isDashboardV2">
        <div class="w-full border-b-2 mb-4"></div>
        <div
          class="station-form-category-container mb-4 text-left"
          data-testid="consult-bulk-sector-specialty"
        >
          <div class="flex items-center gap-2">
            <span class="station-form-category-title">Setor e especialidade (opcional)</span>
            <span class="rounded-full bg-primary5 px-2 text-[10px] font-bold text-primary30"
              >NOVO</span
            >
          </div>
          <p
            v-if="moveWarning"
            class="mt-2 rounded bg-amber-50 px-3 py-2 text-sm text-amber-800"
            data-testid="consult-move-sector-warning"
          >
            {{ moveWarning }}
          </p>
          <p
            v-if="moveSpecialtyWarning"
            class="mt-2 rounded bg-amber-50 px-3 py-2 text-sm text-amber-800"
            data-testid="consult-move-specialty-warning"
          >
            {{ moveSpecialtyWarning }}
          </p>
          <BulkSectorSpecialtyFields
            class="mt-3"
            v-model:sector="bulkSector"
            v-model:specialty="bulkSpecialty"
            :items="fieldItems"
            :sector-locked-reason="sectorLockedReason"
            :disabled-reason="bulkDisabledReason"
          />
          <p
            v-if="serverPreview"
            class="mt-2 rounded bg-primary5 px-3 py-2 text-sm text-gray-800"
            data-testid="consult-bulk-server-preview"
          >
            {{ serverPreview }}
          </p>
        </div>
      </template>
    </div>
    <div
      v-if="false"
      class="text-left input w-full flex flex-col input mt-2 max-h-[420px] px-[8px] overflow-y-scroll"
    >
      <div class="mt-6 flex justify-between gap-5">
        <v-text-field
          v-model="formStates.value"
          class="w-full"
          prefix="R$"
          type="number"
          label="Valor acordado com o médico"
          color="primary20"
          variant="outlined"
          density="comfortable"
        />
      </div>
      <div class="flex flex-col">
        <div class="flex gap-5">
          <v-text-field
            v-model="formStates.date"
            v-maska="'##/##/####'"
            label="Dia"
            class="w-full"
            color="primary20"
            variant="outlined"
            :error="formStates.hasErrorDate"
            :error-messages="formStates.hasErrorDate ? 'Campo obrigatório' : ''"
            density="comfortable"
          />
          <v-autocomplete
            v-model="formStates.timezone"
            class="w-full"
            color="primary20"
            label="Fuso Horário"
            theme="light"
            :items="timezones"
            variant="outlined"
            :error="formStates.hasErrorDate"
            :error-messages="formStates.hasErrorDate ? 'Campo obrigatório' : ''"
            density="comfortable"
          >
            <template v-slot:item="{ props, item }">
              <v-list-item
                v-bind="props"
                :title="item?.raw?.title"
                :subtitle="item?.raw?.subtitle"
              />
            </template>
          </v-autocomplete>
        </div>
        <div class="flex gap-5">
          <v-text-field
            v-model="formStates.startHour"
            v-maska="'##:##'"
            label="Início"
            class="w-full"
            color="primary20"
            variant="outlined"
            :error="formStates.hasErrorDate"
            :error-messages="formStates.hasErrorDate ? 'Campo obrigatório' : ''"
            density="comfortable"
          />
          <v-text-field
            v-model="formStates.endHour"
            v-maska="'##:##'"
            label="Fim"
            class="w-full"
            color="primary20"
            variant="outlined"
            :error="formStates.hasErrorDate"
            :error-messages="formStates.hasErrorDate ? 'Campo obrigatório' : ''"
            density="comfortable"
          />
        </div>
      </div>

      <div class="flex gap-7 mt-4">
        <div>
          <span class="font-bold">Tipo de plantão</span>
          <v-radio-group density="compact" v-model="formStates.stationType" column>
            <v-radio label="Fixo" color="primary" value="FIXO" />
            <v-radio label="Cobertura" color="primary" value="COBERTURA" />
          </v-radio-group>
        </div>
        <div>
          <span class="font-bold">Nossa equipe</span>
          <v-radio-group density="compact" v-model="formStates.ourTeam" column>
            <v-radio label="Sim" color="primary" :value="true" />
            <v-radio label="Não" color="primary" :value="false" />
          </v-radio-group>
        </div>
      </div>
      <div class="flex gap-7 mt-4">
        <div>
          <span class="font-bold">Pagamento á vista</span>
          <v-radio-group density="compact" v-model="formStates.inCash" column>
            <v-radio label="Sim" color="primary" :value="true" />
            <v-radio label="Não" color="primary" :value="false" />
          </v-radio-group>
        </div>
        <div>
          <span class="font-bold">Antecipação Solicitada</span>
          <v-radio-group density="compact" v-model="formStates.advanceRequested" column>
            <v-radio label="Sim" color="primary" :value="true" />
            <v-radio label="Não" color="primary" :value="false" />
          </v-radio-group>
        </div>
        <div>
          <span class="font-bold">Antecipação Paga</span>
          <v-radio-group density="compact" v-model="formStates.advancePaid" column>
            <v-radio label="Sim" color="primary" :value="true" />
            <v-radio label="Não" color="primary" :value="false" />
          </v-radio-group>
        </div>
      </div>

      <!-- <DoctorChecks @saveChecks="handleUpdateChecks" :infos="formStates.histories" /> -->
    </div>

    <!-- Médico "coringa" (422): a edição em lote não tem seletor de cobertura, só "Entendi". -->
    <PlaceholderDoctorBlockedModal
      v-if="placeholderBlocked.isOpen.value"
      v-model="placeholderBlocked.isOpen.value"
      :doctor-name="placeholderBlocked.doctorName.value"
      :allow-unidentified="false"
    />

    <template #footer>
      <div class="flex gap-5 justify-end mt-4 px-3">
        <filled-button
          :loading="formStates.isLoading"
          @click="handleSubmit"
          text="Salvar alterações"
          height="52px"
          width="180px"
        />
      </div>
    </template>
  </modal-vue>
</template>

<script lang="ts">
import { computed, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { useDoctorStore } from '@/pinia-store/useDoctorStore'
import {
  HistoryDate,
  type BulkSectorSpecialtyRequest
} from '@/Network/Types/Requests/StationRequests'
import { timezones } from '@/hooks/useCommon'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import {
  formStates,
  executeSubmit,
  clear,
  executeAllRowsSubmit,
  executeMoveSubmit,
  executeSectorSpecialtySubmit,
  hasBaseFormValues,
  previewSectorSpecialtySubmit,
  rowSector,
  rowSpecialty,
  rowStationId,
  rowToBulkItem
} from './useStation'
import BulkSectorSpecialtyFields from '@/components/SectorSpecialty/BulkSectorSpecialtyFields.vue'
import {
  buildBulkRequest,
  describeBulkCounts,
  describeServerPreview,
  type BulkFieldState,
  type BulkItem
} from '@/modules/company/Dashboard/lenses/bulkPreview'
import type {
  BulkSectorSpecialtyResponse,
  MoveStationsResponse,
  PatchStationsResponse,
  RowConsultingResponse,
  StationSectorRef
} from '@/Network/Types/Responses/StationResponses'
import type { SpecialtySelection } from '@/utils/sectorSpecialty'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import PricesForm from '@/modules/company/Dashboard/modals/createStation/components/form/prices.form.vue'
import LocaleAndScheduleForm from '@/modules/company/Dashboard/modals/createStation/components/form/locale.and.schedule.form.vue'
import StationDetailsForm from '@/modules/company/Dashboard/modals/createStation/components/form/station.details.form.vue'
import HourAndDateForm from '@/modules/company/Dashboard/modals/createStation/components/form/hours.and.date.form.vue'
import { PropType, onMounted, onBeforeUnmount } from 'vue'
import { FilterStates } from '@/components/Filters/useFilterStation'
import PlaceholderDoctorBlockedModal from '@/components/Coverage/PlaceholderDoctorBlockedModal.vue'
import { usePlaceholderDoctorBlocked } from '@/composables/usePlaceholderDoctorBlocked'
import { findDoctorTitle } from '@/utils/placeholderDoctor'

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    infos: {
      type: Array<number>
    },
    ids: {
      type: Array<number>
    },
    isSelectAll: {
      type: Boolean,
      default: false
    },
    totalRows: {
      type: Number
    },
    filters: { type: Object as PropType<FilterStates> },
    /** Linhas da página atual da Consulta (fonte de `stationId`, unidade e valores atuais). */
    rows: { type: Array as PropType<RowConsultingResponse[]>, default: () => [] }
  },
  components: {
    ModalVue,
    FilledButton,
    LocaleAndScheduleForm,
    PricesForm,
    StationDetailsForm,
    HourAndDateForm,
    BulkSectorSpecialtyFields,
    PlaceholderDoctorBlockedModal
  },
  setup(props, { emit }) {
    /* ******** Modal Props and Actions Default *********** */
    const modalName = EModals.UPDATE_BULK_STATION
    const { modals } = storeToRefs(useModalStore())
    const modalStore = useModalStore()
    // Médico "coringa" (422 PLACEHOLDER_DOCTOR_BLOCKED): aviso descritivo em vez do toast.
    const placeholderBlocked = usePlaceholderDoctorBlocked()
    const handleToggleModal = () => {
      clear()
      resetBulk()
      // Abrir/fechar a edição em lote nunca reaproveita o aviso de uma tentativa anterior.
      placeholderBlocked.close()
      modalStore.toggleModal(modalName)
    }
    /* **************************************************** */

    const validationState = ref({ isValid: false, message: null as string | null })

    const handleValidation = (status: { isValid: boolean; message: string | null }) => {
      validationState.value = status
    }

    /* ******** Setor e especialidade (H8-b) *********** */
    // A11: com a flag desligada não há seção, prévia (dryRun), lote nem aviso novo de mover.
    const isDashboardV2 = !!useFeatureFlags().flags.enabledDashboardV2
    const bulkSector = ref<BulkFieldState<StationSectorRef>>({ mode: 'keep', value: null })
    const bulkSpecialty = ref<BulkFieldState<SpecialtySelection>>({ mode: 'keep', value: null })
    const resetBulk = () => {
      bulkSector.value = { mode: 'keep', value: null }
      bulkSpecialty.value = { mode: 'keep', value: null }
    }

    /** A edição em lote da Consulta exige empresa no filtro: é a empresa de origem das linhas. */
    const originCompanyId = computed(() =>
      props.filters?.company ? Number(props.filters.company) : null
    )
    const selectedRows = computed(() => {
      const ids = new Set(props.ids ?? [])
      return (props.rows ?? []).filter((row) => ids.has(row.id))
    })
    /** Todas as linhas selecionadas presentes e com o id do PLANTÃO (o lote não aceita o da alocação). */
    const hasAllStationIds = computed(
      () =>
        selectedRows.value.length > 0 &&
        selectedRows.value.length === (props.ids?.length ?? 0) &&
        selectedRows.value.every((row) => rowStationId(row) !== null)
    )
    const bulkItems = computed<BulkItem[]>(() =>
      hasAllStationIds.value
        ? selectedRows.value
            .map((row) => rowToBulkItem(row, originCompanyId.value))
            .filter((item): item is BulkItem => item !== null)
        : []
    )

    const destinationUnitId = computed(() =>
      formStates.schedule && formStates.healthUnit ? Number(formStates.healthUnit) : null
    )
    const destinationCompanyId = computed(() =>
      formStates.schedule && formStates.company ? Number(formStates.company) : null
    )
    /**
     * Os avisos de mover leem as LINHAS (não os itens do lote): valem mesmo sem `stationId`.
     * Unidade de origem desconhecida (BE sem `healthUnitId`) conta como mudança: melhor avisar a mais.
     */
    const leavesUnit = (row: RowConsultingResponse) =>
      (row.healthUnitId ?? null) !== destinationUnitId.value
    const isMovingUnit = computed(
      () =>
        destinationUnitId.value !== null &&
        (props.isSelectAll || selectedRows.value.some(leavesUnit))
    )
    const isMovingCompany = computed(
      () =>
        destinationCompanyId.value !== null &&
        originCompanyId.value !== null &&
        destinationCompanyId.value !== originCompanyId.value
    )

    /** H8/Q30: quem muda de unidade perde o setor; o BE limpa e devolve `sectorCleared`. */
    const moveWarning = computed(() => {
      if (!isMovingUnit.value || destinationUnitId.value === null) return null
      if (props.isSelectAll) return 'Plantões que mudarem de unidade ficarão sem setor.'
      // Q30: só perde o setor quem tinha setor e muda de unidade.
      const n = selectedRows.value.filter((row) => rowSector(row) && leavesUnit(row)).length
      if (!n) return null
      return n === 1
        ? '1 plantão mudará de unidade e ficará sem setor.'
        : `${n} plantões mudarão de unidade e ficarão sem setor.`
    })
    /** A9: mudar de empresa limpa a especialidade DA EMPRESA (a oficial fica). */
    const moveSpecialtyWarning = computed(() => {
      if (!isMovingCompany.value) return null
      if (props.isSelectAll)
        return 'Plantões que mudarem de empresa ficarão sem a especialidade da empresa.'
      // A9: só a especialidade DA EMPRESA cai (a oficial é global).
      const n = selectedRows.value.filter((row) => rowSpecialty(row)?.source === 'company').length
      if (!n) return null
      return n === 1
        ? '1 plantão mudará de empresa e ficará sem a especialidade da empresa.'
        : `${n} plantões mudarão de empresa e ficarão sem a especialidade da empresa.`
    })

    /**
     * Itens do bloco: ao mudar de empresa, o "Definir especialidade" oferece o catálogo da
     * empresa de DESTINO (o lote roda depois de mover); os chips "atuais" seguem os da origem.
     */
    const fieldItems = computed<BulkItem[]>(() =>
      isMovingCompany.value
        ? bulkItems.value.map((item) => ({ ...item, companyId: destinationCompanyId.value }))
        : bulkItems.value
    )
    const unitCount = computed(() => new Set(bulkItems.value.map((item) => item.healthUnitId)).size)
    const sectorLockedReason = computed(() => {
      if (isMovingUnit.value) return 'Indisponível ao mover'
      if (unitCount.value > 1) return `Indisponível: ${unitCount.value} unidades`
      return null
    })
    const bulkDisabledReason = computed(() => {
      if (props.isSelectAll)
        return 'Setor e especialidade em lote só para plantões selecionados um a um (não com “Selecionar todos”).'
      if (!hasAllStationIds.value)
        return 'Setor e especialidade em lote indisponíveis: a Consulta ainda não traz o plantão destas linhas.'
      return null
    })

    const bulkRequest = computed(() =>
      !isDashboardV2 || bulkDisabledReason.value
        ? null
        : buildBulkRequest(
            bulkItems.value.map((item) => item.stationId),
            bulkSector.value,
            bulkSpecialty.value
          )
    )

    /**
     * Prévia do BE (`dryRun`, A8) por cima da local; se falhar, fica só a local. Suprimida ao
     * mover: o lote roda DEPOIS do mover e a prévia de agora veria unidade/empresa/valores de origem.
     */
    const isMoving = computed(() => isMovingUnit.value || isMovingCompany.value)
    const serverResult = ref<BulkSectorSpecialtyResponse | null>(null)
    let previewSeq = 0
    watch(
      [bulkRequest, () => modals.value[modalName], isMoving],
      async ([body, open, moving]) => {
        const seq = ++previewSeq
        serverResult.value = null
        if (!body || !open || moving) return
        try {
          const result = await previewSectorSpecialtySubmit(body)
          if (seq === previewSeq) serverResult.value = result
        } catch {
          // fallback intencional: sem prévia do BE, a local já está na tela e o salvar segue livre.
        }
      },
      { immediate: true }
    )
    const serverPreview = computed(() =>
      serverResult.value ? describeServerPreview(serverResult.value) : null
    )

    const describeSectorSpecialtyApplied = (result: BulkSectorSpecialtyResponse): string => {
      const n = result.updated
      const label = n === 1 ? 'plantão atualizado' : 'plantões atualizados'
      return `Setor e especialidade: ${n} ${label} (${describeBulkCounts(result)}).`
    }
    const describeMoveCleared = (result: PatchStationsResponse | MoveStationsResponse): string => {
      const parts: string[] = []
      const sector = result?.sectorCleared ?? 0
      const specialty = result?.specialtyCleared ?? 0
      if (sector) parts.push(`${sector} ${sector === 1 ? 'ficou' : 'ficaram'} sem setor`)
      if (specialty)
        parts.push(
          `${specialty} ${specialty === 1 ? 'ficou' : 'ficaram'} sem a especialidade da empresa`
        )
      return parts.length ? `. ${parts.join(' e ')}.` : ''
    }
    /* **************************************************** */

    /* ******** Form Submited  *********** */
    const toast = useToast()
    const { notifyError, notifyErrorMessage } = useErrorToast()
    const { listDoctorsCompany } = storeToRefs(useDoctorStore())
    /** Avisa a falha do PATCH base; `true` quando foi o médico coringa (o aviso abriu). */
    const notifyBaseError = (
      error: unknown,
      fallbackMessage = 'Não foi possível editar os plantões'
    ): boolean => {
      const name = findDoctorTitle(listDoctorsCompany.value, formStates.doctor)
      if (placeholderBlocked.handleError(error, name)) return true
      notifyError(error, fallbackMessage)
      return false
    }
    const finishSubmit = () => {
      emit('refreshData')
      clear()
      resetBulk()
      handleToggleModal()
    }
    const submitBase = async () => {
      const patchResult = props.isSelectAll
        ? await executeAllRowsSubmit(props.filters)
        : await executeSubmit(props.ids)
      toast.success(
        `Plantões editado com sucesso${isDashboardV2 ? describeMoveCleared(patchResult) : ''}`
      )
    }
    /** Grava o lote com toast próprio; devolve se gravou (a falha já foi avisada). */
    const submitSectorSpecialty = async (
      request: BulkSectorSpecialtyRequest,
      errorMessage: string
    ): Promise<boolean> => {
      try {
        const result = await executeSectorSpecialtySubmit(request)
        toast.success(describeSectorSpecialtyApplied(result))
        return true
      } catch (error: unknown) {
        notifyError(error, errorMessage)
        return false
      }
    }
    /**
     * Mover (escala de destino preenchida, seleção um a um): vai pela rota própria
     * `PATCH /stations/bulk/move` com os ids do PLANTÃO — com ou sem a flag V2 (o mover pelo
     * `PATCH /stations/bulk` de corpo plano dava 400). "Selecionar todos" segue no `/bulk/all`.
     */
    const moveTargetScheduleId = computed(() =>
      !props.isSelectAll && formStates.schedule ? Number(formStates.schedule) : null
    )
    /**
     * O mover roda PRIMEIRO e é tudo-ou-nada no BE: falhou → nada mais roda e a mensagem do BE
     * (403/400) vai ao toast. Depois dele, os demais campos (PATCH base, sem a escala) e o lote
     * de setor/especialidade (catálogo da empresa de destino) — falhas avisam, mas o modal
     * fecha e recarrega, porque o mover já valeu.
     */
    const submitMoveFirst = async (
      targetScheduleId: number,
      request: BulkSectorSpecialtyRequest | null
    ) => {
      if (!hasAllStationIds.value) {
        notifyErrorMessage(
          'Não foi possível mover: a Consulta não trouxe o plantão de todas as linhas selecionadas.'
        )
        return
      }
      const stationIds = selectedRows.value.map((row) => rowStationId(row) as number)
      let moved: MoveStationsResponse
      try {
        moved = await executeMoveSubmit(stationIds, targetScheduleId)
      } catch (error: unknown) {
        notifyError(error, 'Não foi possível mover os plantões')
        return
      }
      toast.success(
        `Plantões movidos com sucesso${isDashboardV2 ? describeMoveCleared(moved) : ''}`
      )
      let doctorBlocked = false
      if (hasBaseFormValues({ excludeSchedule: true })) {
        try {
          await executeSubmit(props.ids, { excludeSchedule: true })
          toast.success('Plantões editado com sucesso')
        } catch (error: unknown) {
          doctorBlocked = notifyBaseError(
            error,
            'Plantões movidos, mas não foi possível editar os demais campos'
          )
        }
      }
      if (request)
        await submitSectorSpecialty(
          request,
          'Plantões movidos, mas não foi possível definir setor e especialidade'
        )
      if (doctorBlocked) {
        // O mover já valeu: recarrega a Consulta, mas a edição fica aberta com o aviso à vista.
        toast.info('Plantões movidos. O médico não foi aplicado: veja o aviso.')
        emit('refreshData')
        resetBulk()
        // O mover já foi aplicado: sem a escala de destino, um novo "Salvar" não o repete
        // (os demais campos ficam para o usuário corrigir o médico e salvar de novo).
        formStates.schedule = undefined
        return
      }
      finishSubmit()
    }
    /**
     * Sem mover: o lote é independente do PATCH /stations/bulk (que ainda falha com corpo plano —
     * bug da base). Roda primeiro, com toast próprio; o PATCH base só se houver campo preenchido.
     */
    const submitSectorSpecialtyThenBase = async (request: BulkSectorSpecialtyRequest) => {
      const applied = await submitSectorSpecialty(
        request,
        'Não foi possível definir setor e especialidade'
      )
      if (!hasBaseFormValues()) {
        if (applied) finishSubmit()
        return
      }
      try {
        await submitBase()
      } catch (error: unknown) {
        notifyBaseError(error)
        if (applied) {
          // O lote já gravou: recarrega e limpa o bloco para um novo salvar não repeti-lo.
          emit('refreshData')
          resetBulk()
        }
        return
      }
      finishSubmit()
    }
    const handleSubmit = async () => {
      try {
        formStates.isLoading = true

        if (!validationState.value.isValid)
          return toast.error(
            `Erro no preenchimentos das datas: ${validationState.value.message || ''}`
          )

        const request = bulkRequest.value
        const targetScheduleId = moveTargetScheduleId.value
        if (targetScheduleId !== null) return await submitMoveFirst(targetScheduleId, request)
        // Sem lote de setor/especialidade (sempre com a flag OFF): fluxo da base.
        if (!request) {
          await submitBase()
          return finishSubmit()
        }
        await submitSectorSpecialtyThenBase(request)
      } catch (error: unknown) {
        // Antes: leitura direta de error.response.data.message (toast vazio quando
        // ausente). O service normaliza via handleError — notifyError extrai a mensagem.
        notifyBaseError(error)
      } finally {
        formStates.isLoading = false
      }
    }
    /* **************************************************** */
    /* ******** Form Select List *********** */
    // A cascata empresa -> unidade -> escala é responsabilidade do
    // LocaleAndScheduleForm, que chama setHealthUnitsByCompany e lê
    // listHealthUnitsByCompany. Os handlers companyChanged/healthUnitChanged
    // que existiam aqui nunca foram ligados no template — só escreviam no
    // healthUnitQuery compartilhado do store, vazando o filtro de empresa para
    // as outras telas que leem listHealthUnits.
    const { listCompanies } = storeToRefs(useCompanyStore())
    const { listSchedules } = storeToRefs(useScheduleStore())
    /* **************************************************** */

    const handleUpdateChecks = (h: HistoryDate[]) => (formStates.histories = h)

    // Função para fechar o modal ao pressionar ESC
    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        // O ESC do aviso do médico coringa fecha só o aviso.
        if (placeholderBlocked.isOpen.value) return
        handleToggleModal()
      }
    }

    onMounted(() => {
      window.addEventListener('keydown', handleKeydown)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('keydown', handleKeydown)
    })

    return {
      modalName,
      modals,
      handleToggleModal,
      formStates,
      listDoctorsCompany,
      listCompanies,
      listSchedules,
      timezones,
      handleSubmit,
      handleUpdateChecks,
      handleValidation,
      isDashboardV2,
      bulkSector,
      bulkSpecialty,
      fieldItems,
      moveWarning,
      moveSpecialtyWarning,
      sectorLockedReason,
      bulkDisabledReason,
      serverPreview,
      placeholderBlocked
    }
  }
}
</script>
